import { BaseRestDataProvider } from './BaseRestDataProvider';

export interface RiskItem {
  id: string;
  name: string;
  impact: string;
  severity: number;
  likelihood: number;
  owner: string;
  mitigation: string;
  phase: string;
}

export class RisksRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/risks');
  }

  getAll(): Promise<RiskItem[]> {
    return this.get<RiskItem[]>(``);
  }

  getById(id: string): Promise<RiskItem> {
    return this.get<RiskItem>(`/${id}`);
  }

  create(item: RiskItem): Promise<RiskItem> {
    return this.post<RiskItem>(``, item);
  }

  update(id: string, item: RiskItem): Promise<void> {
    return this.put<void>(`/${id}`, item);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}
